module.exports = __webpack_public_path__ + "create/static/media/cover-profile.d52ba7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateGym/Steps/BioProfile/cover-profile.jpg
// module id = 491
// module chunks = 37